import { ArrowUpRight } from "lucide-react";
import { SITE } from "@/config";
import { Chapter, Reveal } from "@/components/Reveal";
import { GhostCTA } from "@/components/CTA";

const Books = () => (
  <section id="libri" data-testid="books-section" className="bg-fog py-28 text-ink lg:py-40">
    <div className="mx-auto max-w-[1440px] px-6 lg:px-12">
      <Chapter index="08" label="Libri & Strumenti" />
      <div className="grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Reveal>
            <div className="relative max-w-[320px]">
              <div className="absolute -left-3 -top-3 h-full w-full border border-accent-dark/30" aria-hidden="true" />
              <img
                src="/assets/beauty-task-cover.webp"
                alt="Beauty Task — copertina del libro di Mattia Cosimo Saracino"
                loading="lazy"
                data-testid="book-cover"
                className="relative h-auto w-full"
                style={{ boxShadow: "0 24px 60px rgba(5,5,5,0.28)" }}
              />
            </div>
          </Reveal>
        </div>
        <div className="flex flex-col justify-center lg:col-span-8">
          <Reveal>
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-ink/40">Libri & strumenti</p>
            <h2 className="mt-4 font-display text-4xl font-extrabold tracking-tighter sm:text-5xl">
              BEAUTY TASK
            </h2>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-ink/60 md:text-lg">
              La guida semplice per imprenditori e imprenditrici nel beauty che vogliono guadagnare
              e uscire dall'operatività quanto prima.
            </p>
          </Reveal>
          <Reveal delay={0.1} className="mt-10 flex flex-wrap items-center gap-4">
            <GhostCTA to="/progetti" testid="book-cta-scopri">
              Scopri il libro
            </GhostCTA>
            <a
              href={SITE.amazonBeautyTask}
              data-testid="book-cta-amazon"
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center gap-3 border border-ink/25 px-7 py-4 font-mono text-[11px] font-medium uppercase tracking-[0.22em] text-ink transition-colors duration-300 hover:border-accent-dark hover:text-accent-dark"
            >
              Acquista su Amazon
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
            </a>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

export default Books;
